import React from "react";
import { Box } from "@mui/material";
import PageShell from "./PageShell";
import { PageBreadcrumbs, PageTitleBlock } from "./PageHeader";
import PageToolbar from "./PageToolbar";
import FilterDrawer from "./FilterDrawer";

const ListPageLayout = ({
  breadcrumbs,
  title,
  subtitle,
  searchValue,
  onSearchChange,
  onSearchSubmit,
  searchPlaceholder,
  showSearch = true,
  showFilters = true,
  filterOpen,
  onFiltersClick,
  onFilterClose,
  filterActive = false,
  filterTitle = "Filters",
  onFilterApply,
  onFilterReset,
  filterContent,
  createLabel,
  onCreateClick,
  extraActions,
  children,
}) => (
  <PageShell>
    <PageBreadcrumbs breadcrumbs={breadcrumbs} />

    <Box
      className="page-header-row"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap",
        mb: 2.5,
      }}
    >
      <PageTitleBlock title={title} subtitle={subtitle} />
      <PageToolbar
        searchValue={searchValue}
        onSearchChange={onSearchChange}
        onSearchSubmit={onSearchSubmit}
        searchPlaceholder={searchPlaceholder}
        showSearch={showSearch}
        showFilters={showFilters}
        onFiltersClick={onFiltersClick}
        filterActive={filterActive}
        createLabel={createLabel}
        onCreateClick={onCreateClick}
        extraActions={extraActions}
        embedded
      />
    </Box>

    {showFilters && (
      <FilterDrawer
        open={filterOpen}
        onClose={onFilterClose}
        title={filterTitle}
        onApply={onFilterApply}
        onReset={onFilterReset}
      >
        {filterContent}
      </FilterDrawer>
    )}
    {children}
  </PageShell>
);

export default ListPageLayout;
